import * as React from "react";
import "../css/simple-text.css";
import Navigation from "../components/navigation";
import Footer from "../components/footer";

export default function Datenschutz() {
  return (
    <>
      <div>
        <Navigation/>
        <div>
          <div className="content--simple-text"></div>
          <div className="content--simple-text"></div>
          <div className="content--simple-text"><h1><strong>Datenschutzerklärung</strong></h1>
            <p>Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO),
              ist:
              Tim Martin</p>
            <p><strong>Postanschrift:</strong>
              Rischbachstraße 17
              66386 St Ingbert</p>
            <p><strong>Kontakt:</strong>
              Telefon: 06894 5820122
              E-Mail: timarnemartin@gmx.de</p>
            <h2><strong>Ihre Betroffenenrechte</strong></h2>
            <p>Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte
              ausüben:
              Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),
              Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),
              Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),
              Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht
              löschen dürfen (Art. 18 DSGVO),
              Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und
              Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns
              abgeschlossen haben (Art. 20 DSGVO).
              Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft
              widerrufen.
              Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige
              Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als verantwortliche Stelle
              zuständige
              Behörde.
              Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter:
              https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html.</p>
            <p><strong>Drittlandtransfer:</strong>
              Die erhobenen Daten werden ggfs. in folgende Drittländer übertragen:
              Nein
              Folgende Datenschutzgarantien liegen vor:</p>
            <h2><strong>Cookies</strong></h2>
            <p>Wie viele andere Webseiten verwenden wir auch so genannte „Cookies“. Bei Cookies handelt es sich um
              kleine
              Textdateien, die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere
              Webseite besuchen.
              Sie können Sie einzelne Cookies oder den gesamten Cookie-Bestand löschen. Darüber hinaus erhalten Sie
              Informationen und Anleitungen, wie diese Cookies gelöscht oder deren Speicherung vorab blockiert werden
              können. Je nach Anbieter Ihres Browsers finden Sie die notwendigen Informationen unter den nachfolgenden
              Links:</p>
            <p>Mozilla Firefox: https://support.mozilla.org/de/kb/cookies-loeschen-daten-von-websites-entfernen
              Internet Explorer:
              https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies
              Google Chrome: https://support.google.com/accounts/answer/61416?hl=de
              Opera: http://www.opera.com/de/help
              Safari: https://support.apple.com/kb/PH17191?locale=de_DE&amp;viewlocale=de_DE</p>
            <p><strong>Speicherdauer und eingesetzte Cookies:</strong>
              Soweit Sie uns durch Ihre Browsereinstellungen oder Zustimmung die Verwendung von Cookies erlauben, können
              folgende Cookies auf unseren Webseiten zum Einsatz kommen:</p>
            <h2>Technisch notwendige Cookies</h2>
            <p><strong>Art und Zweck der Verarbeitung:</strong>
              Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer
              Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden
              kann.
              Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die Nutzer zu
              vereinfachen. Einige Funktionen unserer Internetseite können ohne den Einsatz von Cookies nicht angeboten
              werden. Für diese ist es erforderlich, dass der Browser auch nach einem Seitenwechsel wiedererkannt wird.
            </p>
            <p><strong>Für folgende Anwendungen benötigen wir Cookies:</strong></p>
            <p><strong>Rechtsgrundlage und berechtigtes Interesse:</strong>
              Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an
              einer
              nutzerfreundlichen Gestaltung unserer Website.</p>
            <p><strong>Empfänger:</strong>
              Empfänger der Daten sind ggf. technische Dienstleister, die für den Betrieb und die Wartung unserer
              Website
              als Auftragsverarbeiter tätig werden.
              Bereitstellung vorgeschrieben oder erforderlich:
              Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder gesetzlich noch vertraglich
              vorgeschrieben. Ohne diese Daten ist jedoch der Dienst und die Funktionsfähigkeit unserer Website nicht
              gewährleistet. Zudem können einzelne Dienste und Services nicht verfügbar oder eingeschränkt sein.</p>
            <p><strong>Widerspruch</strong>
              Lesen Sie dazu die Informationen über Ihr Widerspruchsrecht nach Art. 21 DSGVO weiter unten.</p>
            <h2>Kontaktformular</h2>
            <p>Art und Zweck der Verarbeitung:
              Die von Ihnen eingegebenen Daten werden zum Zweck der individuellen Kommunikation mit Ihnen gespeichert.
              Hierfür ist die Angabe einer validen E-Mail-Adresse sowie Ihres Namens erforderlich. Diese dient der
              Zuordnung der Anfrage und der anschließenden Beantwortung derselben. Die Angabe weiterer Daten ist
              optional.</p>
            <p><strong>Rechtsgrundlage:</strong>
              Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt auf der Grundlage eines
              berechtigten
              Interesses (Art. 6 Abs. 1 lit. f DSGVO).
              Durch Bereitstellung des Kontaktformulars möchten wir Ihnen eine unkomplizierte Kontaktaufnahme
              ermöglichen.
              Ihre gemachten Angaben werden zum Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen
              gespeichert.
              Sofern Sie mit uns Kontakt aufnehmen, um ein Angebot zu erfragen, erfolgt die Verarbeitung der in das
              Kontaktformular eingegebenen Daten zur Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b
              DSGVO).
            </p>
            <p><strong>Empfänger:</strong>
              Empfänger der Daten sind ggf. Auftragsverarbeiter.</p>
            <p><strong>Drittlandtransfer:</strong>
              Die erhobenen Daten werden ggfs. in folgende Drittländer übertragen:
              Nein
              Folgende Datenschutzgarantien liegen vor:</p>
            <p><strong>Speicherdauer:</strong>
              Daten werden spätestens 6 Monate nach Bearbeitung der Anfrage gelöscht.
              Sofern es zu einem Vertragsverhältnis kommt, unterliegen wir den gesetzlichen Aufbewahrungsfristen nach
              HGB
              und löschen Ihre Daten nach Ablauf dieser Fristen.</p>
            <p><strong>Bereitstellung vorgeschrieben oder erforderlich:</strong>
              Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig. Wir können Ihre Anfrage jedoch nur
              bearbeiten, sofern Sie uns Ihren Namen, Ihre E-Mail-Adresse und den Grund der Anfrage mitteilen.</p>
            <p><strong>Verwendung von Scriptbibliotheken (Google Webfonts)</strong>
              Um unsere Inhalte browserübergreifend korrekt und grafisch ansprechend darzustellen, verwenden wir auf
              dieser Website „Google Web Fonts“ der Google LLC (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA;
              nachfolgend „Google“) zur Darstellung von Schriften.
              Weitere Informationen zu Google Web Fonts finden Sie unter https://developers.google.com/fonts/faq und in
              der Datenschutzerklärung von Google: https://www.google.com/policies/privacy/.</p>
            <p><strong>SSL-Verschlüsselung</strong>
              Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der
              Technik
              entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.</p>
            <h2><strong>Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO</strong></h2>
            <p><strong>Einzelfallbezogenes Widerspruchsrecht</strong>
              Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die
              Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund Art. 6 Abs. 1 lit. f DSGVO
              (Datenverarbeitung auf der Grundlage einer Interessenabwägung) erfolgt, Widerspruch einzulegen; dies gilt
              auch für ein auf diese Bestimmung gestütztes Profiling im Sinne von Art. 4 Nr. 4 DSGVO.
              Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei denn,
              wir
              können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
              Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
              Rechtsansprüchen.</p>
            <p><strong>Empfänger eines Widerspruchs</strong></p>
            <p>Tim Martin</p>
            <p><strong>Postanschrift:</strong>
              Rischbachstraße 17
              66386 St Ingbert</p>
            <p><strong>Kontakt:</strong>
              Telefon: 06894 5820122
              E-Mail: timarnemartin@gmx.de</p>
            <p><strong>Änderung unserer Datenschutzbestimmungen</strong>
              Fragen an den Datenschutzbeauftragten
              Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an
              die für den Datenschutz verantwortliche Person in unserer Organisation:
              Die Datenschutzerklärung wurde mithilfe der activeMind AG erstellt, den Experten für externe
              Datenschutzbeauftragte (Version #2020-09-30).</p></div>
        </div>
        <Footer/>
      </div>
    </>
  );
}
